module.exports = __webpack_public_path__ + "static/media/user-check.5aa9521a.svg";